import { createAction, props } from '@ngrx/store';

export class NumpadActions {
    static readonly ACTION_SCHEMA = `@numpad`;

    private static readonly NUMPAD_FOCUS = `${NumpadActions.ACTION_SCHEMA}/NUMPAD_FOCUS`;

    static numpadFocus = createAction(NumpadActions.NUMPAD_FOCUS, props<{ numpadFocus: boolean }>());
}
